module.exports = __webpack_public_path__ + "img/panel6.3d0aa9c4.svg";